import React from "react";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import NumberInput from "../../Components/Inputs/NumberInput";

export default function ({register, control, errors, data}) {
  return (
    <>
      <ReactSelectInput
        label='Delivery provider'
        name='delivery_provider'
        control={control}
        errorMessage={errors?.delivery_provider}
        options={data?.deliveryProviders}
        required
      />

      <NumberInput
        label='Price from'
        name='price_from'
        register={register}
        errorMessage={errors?.price_from}
        required
      />

      <NumberInput
        label='Price to'
        name='price_to'
        register={register}
        errorMessage={errors?.price_to}
      />

      <NumberInput
        label='Delivery cost'
        name='cost'
        register={register}
        errorMessage={errors?.cost}
      />
    </>
  );
}